import { Settings } from "@/features/Profile/Settings/Settings";

const SettingsView = () => <Settings />;

export default SettingsView;
